import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useParams } from 'react-router-dom';
import auth from '../../firebase.init';
import HeaderBottom from '../../components/HomePage/HeaderBottom';
import MarginTop from '../../MarginTop';
import './PayNow.css';

const PAYPAL_HOSTED_BUTTON_IDS = {
  599: 'YDQH9UUZ3XZNE',
  299: 'F667KRE43NLP4',
  fallback: '7RDFUSTUKTP3W',
};

const PayNow = () => {
  const [paypal, setPaypal] = useState([]);
  const { id } = useParams();
  const [order, setOrder] = useState([]);
  const [user] = useAuthState(auth);
  const currentDomain = window.location.origin;
  const selectedHostedButtonId =
    PAYPAL_HOSTED_BUTTON_IDS[Number(order.packagePrice)] || PAYPAL_HOSTED_BUTTON_IDS.fallback;

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/order/${id}`)
      .then((res) => res.json())
      .then((info) => setOrder(info));
  }, [id]);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/paypal-email`)
      .then((res) => res.json())
      .then((info) => setPaypal(info));
  }, []);

  useEffect(() => {
    let isCancelled = false;
    let renderInterval = null;

    const renderHostedButton = async () => {
      if (!selectedHostedButtonId || !window.paypal?.HostedButtons) {
        return false;
      }

      const container = document.getElementById(`paypal-container-${selectedHostedButtonId}`);

      if (!container || container.dataset.paypalRendered === 'true') {
        return false;
      }

      container.innerHTML = '';

      try {
        await window.paypal.HostedButtons({
          hostedButtonId: selectedHostedButtonId,
        }).render(`#paypal-container-${selectedHostedButtonId}`);

        if (!isCancelled) {
          container.dataset.paypalRendered = 'true';
        }

        return true;
      } catch (error) {
        console.error('PayPal Hosted Button render failed', error);
        return false;
      }
    };

    if (selectedHostedButtonId) {
      renderHostedButton();
      renderInterval = window.setInterval(async () => {
        const rendered = await renderHostedButton();

        if (rendered && renderInterval) {
          window.clearInterval(renderInterval);
        }
      }, 300);
    }

    return () => {
      isCancelled = true;

      if (renderInterval) {
        window.clearInterval(renderInterval);
      }
    };
  }, [selectedHostedButtonId]);

  return (
    <>
          <HeaderBottom />
      <section id="services" className="services-area vh-100">
 
    
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
              {/* Bootstrap Card for Payment */}
              <div className="card shadow-lg border-0">
                <div className="card-body p-4">
                  <h2 className="card-title text-center mb-4">Proceed with Your PayPal Payment</h2>
                 
                  <h4 className="text-center text-muted mb-4">
                    Package Name : {order.packageName} Plan
                  </h4>
                  <h6 className="text-center text-muted mb-4">
                    Order #{order._id} - Total: ${order.packagePrice}
                  </h6>
                  <form
                    action="https://www.paypal.com/cgi-bin/webscr"
                    method="post"
                    target="_top"
                    className="text-center"
                  >
                    {paypal.map((e, index) => (
                      <input
                        key={index}
                        name="business"
                        hidden
                        value={e.paypalEmail}
                      />
                    ))}

                    <input type="hidden" name="item_number" value="1" />
                    <input type="hidden" name="amount" value={order.packagePrice} />
                    <input type="hidden" name="no_shipping" value="1" />
                    <input type="hidden" name="currency_code" value="USD" />
                    <input
                      type="hidden"
                      name="notify_url"
                      value="http://sitename/paypal-payment-gateway-integration-in-php/notify.php"
                    />
                    <input
                      type="hidden"
                      name="cancel_return"
                      value={`${currentDomain}/order-cancelled/${order._id}/${order.paymentId}`}
                    />
                    <input
                      type="hidden"
                      name="return"
                      value={`${currentDomain}/order-cancelled/${order._id}/${order.paymentId}`}
                    />
                    <input type="hidden" name="cmd" value="_xclick" />
                    {!selectedHostedButtonId && (
                      <button
                        type="submit"
                        className="py-3 px-4  button-professional  mt-3"
                      >
                        <i className="bi bi-paypal me-2"></i>Pay Now with PayPal
                      </button>
                    )}
                    {selectedHostedButtonId && (
                      <div id={`paypal-container-${selectedHostedButtonId}`}></div>
                    )}

                  </form>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default PayNow;
